import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="validation-matricula"
export default class extends Controller {
  static targets = [ "form", "matriculaInput", "nombreInput", "tabs" ]
  static values = {
    id: String
  }

  connect() {
    this.element.addEventListener('keydown', this.handleKeydown.bind(this));
    try {
      if (this.hasMatriculaInputTarget && this.matriculaInputTarget) {
        this.matriculaInputTarget.addEventListener('input', () => {
          const hidden = document.querySelector('#matriculaValidacionModal [data-autocomplete-target="hidden"]');
          if (hidden) hidden.value = '';
        });
      }
    } catch (e) {}
  }

  disconnect() {
    this.element.removeEventListener('keydown', this.handleKeydown.bind(this));
  }

  handleKeydown(event) {
    if (event.key === 'Enter') {
      event.preventDefault();

      const matriculaValue = this.matriculaInputTarget.value;

      if (matriculaValue) {
        this.submitForm();
      } else {
        this.matriculaInputTarget.focus();
      }
    }
  }

  openModal(e) {
    e.preventDefault();
    this.originalSubmitButton = e.target;
    if (this.originalSubmitButton.classList.contains("disabled")) {
      return;
    }

    $('#matriculaValidacionModal').modal('show');
  }

  submitForm() {
    const matriculaTexto = this.hasMatriculaInputTarget ? this.matriculaInputTarget.value.trim() : ''
    const hiddenField = document.querySelector('#matriculaValidacionModal [data-autocomplete-target="hidden"]')
    const matriculaSeleccionada = hiddenField ? (hiddenField.value || '').toString().trim() : ''

    if (matriculaTexto === '' || matriculaSeleccionada === '') {
      alert('Debes seleccionar un profesional del buscador. Escribe y elige una opción de la lista desplegable.');
      return
    }
    
    const form = document.getElementById(this.idValue)
    form.requestSubmit();
    $('#matriculaValidacionModal').modal('hide');
  }

  getActiveTabName() {
    if (!this.hasTabsTarget) return null

    const activeTab = this.tabsTarget.querySelector(".nav-link.active")
    if (activeTab) {
      return activeTab.textContent.trim()
    }
    return null
  }
}
